import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import user from "./auth/authReducer";
import merchantStats from "./merchantStatsReducer";
import driverStats from "./driverStatsReducer";
import merchant, {
  postMerchant,
  patchMerchant,
  editMerchantProfile,
} from "./merchantReducer";
import driver from "./driverReducer";
import trackerInfo from "./trackerReducer";
import logisticsInfo from "./logisticsReducer";
import timeslots from "./timeslotsReducer";
import deliveries from "./deliveriesReducer";
import { postFulfillment } from "./actionReducer";
import { postRoute, getTasks } from "./routeReducer";
import { requestUsers, uzer, searchUsers, postUser } from "./userReducer";
import {
  requestCustomers,
  customer,
  editCustomerProfile,
} from "./customerReducer";
import {
  requestFulfillment,
  requestFulfillmentContact,
} from "./fulfillmentReducer";
import {
  requestDelivery,
  requestContact,
  postDelivery,
  editDelivery,
} from "./deliveryReducer";
import { requestTask, editTask } from "./taskReducer";
import { requestTimeslot, editTimeslot } from "./timeslotReducer";
import { requestInquiry } from "./inquiryReducer";
import { alert } from "./alertReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  user,
  merchant,
  driver,
  merchantStats,
  driverStats,
  trackerInfo,
  logisticsInfo,
  deliveries,
  timeslots,
  requestUsers,
  uzer,
  searchUsers,
  requestCustomers,
  customer,
  editCustomerProfile,
  postFulfillment,
  requestFulfillment,
  requestFulfillmentContact,
  requestDelivery,
  requestInquiry,
  requestContact,
  postDelivery,
  postRoute,
  postUser,
  postMerchant,
  patchMerchant,
  editMerchantProfile,
  editDelivery,
  requestTask,
  editTask,
  requestTimeslot,
  editTimeslot,
  getTasks,
  alert,
});

export default persistReducer(persistConfig, rootReducer);
